import { afterNextRender, ChangeDetectionStrategy, Component, computed, ElementRef, inject, input } from "@angular/core";

import { CardBoxComponent } from "../card-box/card-box.component";
import { CardViewModel } from "../../models/card.vm";
import { RouterModule } from "@angular/router";
import { SafeHtmlPipe } from "../../pages/case-study-page/SafeHtmlPipe";

@Component({
    selector: "in2-case-case-study-slider-card",
    standalone: true,
    imports: [SafeHtmlPipe, RouterModule, CardBoxComponent],
    templateUrl: "./case-study-slider-card.component.html",
    styleUrls: ["./case-study-slider-card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseStudySliderCardComponent {
    slide = input.required<CardViewModel>();
    card = computed(() => {
        const slide = this.slide();
        return {
            title: slide.title,
            img: slide.img,
        } as CardViewModel;
    });

    private observer!: IntersectionObserver;

    private el = inject(ElementRef<HTMLElement>);
    private parentNode = null as HTMLElement | null;
    constructor() {
        afterNextRender(() => {
            this.parentNode = this.el.nativeElement.parentNode as HTMLElement;
            this.parentNode.classList.add("card");

            this.observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(async (entry) => {
                    if (entry.isIntersecting) {
                        this.parentNode.onmouseenter = () => this.mouseEnter(this.parentNode!);
                        this.parentNode.onmouseleave = () => this.mouseLeave(this.parentNode!);
                    }
                    if (entry.boundingClientRect.top > window.innerHeight) {
                        this.parentNode.onmouseenter = null;
                        this.parentNode.onmouseleave = null;
                    }
                });
            });
            this.observer.observe(this.parentNode);
        });
    }

    tmout = null;
    async mouseEnter(slide: HTMLElement) {
        if (slide.classList.contains("flipped")) return;
        this.tmout = setTimeout(() => {
            slide.classList.add("flipped");
            this.tmout = null;
        }, 150);
    }
    mouseLeave(slide: HTMLElement) {
        slide.classList.remove("flipped");
        if (this.tmout) {
            clearTimeout(this.tmout);
            this.tmout = null;
        }
    }
}
